export const toasterStyle = {
  alertStyle: { width: "100%", alignItems: "center" },
};
